import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useMerchandiseLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const orderDisclaimer = intl.formatMessage({
      id: 'HoY_Vvqy1_YtWKVwMFVS',
      defaultMessage: 'Your account will be credited within 30-40 days.',
      description: 'Disclaimer about account credit timeline for merchandise orders',
    })

    const shippingDisclaimer = intl.formatMessage({
      id: 'IbMiMy2QSTu3yq-EtHts',
      defaultMessage: 'Some items may be shipped separately or together. Tracking links will appear once available.',
      description: 'Disclaimer about merchandise shipping and tracking information',
    })

    const travelEssentialsItems = [
      {
        id: 'suitcases',
        name: intl.formatMessage({
          id: 'AJZOaiA_QYB39JxYziKq',
          defaultMessage: 'Suitcases',
          description: 'Travel essentials navigation category name for suitcases',
        }),
        url: '/search/shop/luggage-bags/suitcases',
      },
      {
        id: 'backpacks',
        name: intl.formatMessage({
          id: 'ZXag08z5h3B6mnRNpg9K',
          defaultMessage: 'Backpacks',
          description: 'Travel essentials navigation category name for backpacks',
        }),
        url: '/search/shop/luggage-bags/backpacks',
      },
      {
        id: 'duffel-bags',
        name: intl.formatMessage({
          id: 'asSLm8QiLnsAVnlfRttC',
          defaultMessage: 'Duffel bags',
          description: 'Travel essentials navigation category name for duffel bags',
        }),
        url: '/search/shop/luggage-bags/duffel-bags',
      },
      {
        id: 'audio',
        name: intl.formatMessage({
          id: 'Ld5TcF8l3drunPlwrZo_',
          defaultMessage: 'Audio',
          description: 'Travel essentials navigation category name for audio equipment',
        }),
        url: '/search/shop/electronics/audio',
      },
      {
        id: 'cameras',
        name: intl.formatMessage({
          id: 'Vj8Cs2aQGI-5FVOLMO8P',
          defaultMessage: 'Cameras',
          description: 'Travel essentials navigation category name for cameras',
        }),
        url: '/search/shop/cameras-optics/cameras',
      },
    ]

    const tagDisplayNames: Record<string, string> = {
      triplepoints: intl.formatMessage({
        id: 'WJZyFh9jt2Gw3f_ngKsj',
        defaultMessage: 'Triple Points',
        description: 'Merchandise tag display name for triple points promotion',
      }),
    }

    return {
      orderDisclaimer,
      shippingDisclaimer,
      travelEssentialsItems,
      tagDisplayNames,
    }
  }, [intl])
}

export default useMerchandiseLabels
